import { FoldedCollection, Result } from '@coveo/headless';
import { ResultLink } from '../ResultLink';
import { HighlightedText } from '../HighlightedText';
import { Grid } from '@mui/material';
import { HighlightedTextNewsArticle } from '../HighlightedTextNewsArticle';

export interface INewsArticleResultsProps {
  collection: FoldedCollection;
}

export function NewsArticleResults({ collection }: INewsArticleResultsProps) {
  function getDate(result: Result, fieldName: string) {
    if (result.raw.hasOwnProperty(fieldName)) {
      const date: Date = new Date(result.raw[fieldName] as number);
      return `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()}`;
    }
    return '';
  }

  function renderDate(result: Result) {
    return (
      <Grid container className="result-date caption">
        <Grid size={{ xs: 12 }}>{'Published date: ' + getDate(result, 'lmcpublishdate')}</Grid>
      </Grid>
    );
  }

  function displayExcerpt(result: Result) {
    return result?.raw['lmcsearchdescription'] ? (
      <HighlightedTextNewsArticle value={result?.raw['lmcsearchdescription'] as string} />
    ) : result?.excerpt && result?.excerptHighlights ? (
      <HighlightedText value={result?.excerpt} highlights={result?.excerptHighlights} />
    ) : (
      <></>
    );
  }

  return (
    <article className="result-folding-result">
      <div className="result-folding-title">
        <ResultLink result={collection.result} target="_self">
          {collection.result?.raw['lmcheadline'] ? (
            <HighlightedTextNewsArticle value={collection?.result?.raw['lmcheadline'] as string} />
          ) : collection?.result?.title && collection?.result?.titleHighlights ? (
            <HighlightedText value={collection?.result?.title} highlights={collection?.result?.titleHighlights} />
          ) : (
            <></>
          )}
        </ResultLink>
      </div>
      <div className="result-folding-excerpts caption">
        <ul>
          <li>
            <article>
              <span>{displayExcerpt(collection.result)}</span>
            </article>
          </li>
        </ul>
      </div>
      {collection?.result?.raw['lmcpublishdate'] ? renderDate(collection.result) : <></>}
    </article>
  );
}
